import { render, staticRenderFns } from "./IterationHeader.vue?vue&type=template&id=80ca60e4"
import script from "./IterationHeader.vue?vue&type=script&lang=js"
export * from "./IterationHeader.vue?vue&type=script&lang=js"
import style0 from "./IterationHeader.vue?vue&type=style&index=0&id=80ca60e4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports